import React from "react";
import CandidateSelection from './CandidateSelection';
import Container from 'react-bootstrap/ListGroup';
import { useCandidates } from '../CandidatesContext';

interface OptionsListProps {
  list: any;
}

const BallotInstructions = (data: any): React.ReactNode => {
  if (Array.isArray(data))
  {
    return (
      <>
        <h3>Instructions</h3>
        <ul>
          {(data as string[]).map((instruction, index) => (
            <li key={index}>{instruction}</li>
          ))}
        </ul>
      </>
    );
  }else{
    return <span>Did not get any ballot instructions!</span>;
  }
}

const BallotCandidates = (
  data: any
): React.ReactNode => {
    const { candidates, setCandidates } = useCandidates();
  
  if (Array.isArray(data)) {
    // Render arrays
    return (
      <>
        {data.map((position: any) => (
          <Container style={{ paddingTop: "1rem", paddingBottom: "1rem" }}>
            <CandidateSelection
              key={position.title}
              title={position.title + " - (You may select up to " + position.max_options + ")"}
              options={position.candidates.map((candidate: string) => ({ id: candidate, label: candidate }))}
              selectedId={candidates.find((candidate) => candidate.title === position.title)?.selectedCandidate}
              onChange={(selectedId: string | number | null) => {
                if( selectedId !== null ) {
                  const newCandidates = candidates.map((candidate) => {
                    if (candidate.title === position.title) {
                      return { ...candidate, selectedCandidate: String(selectedId) };
                    } else {
                      return candidate;
                    }
                  });
                  setCandidates(newCandidates);
                }
              }}
            />
          </Container>
        ))}
      </>
    );

  } else {
    return <span>Did not get any candidates!</span>;
  }
}

const OptionsList: React.FC<OptionsListProps> = ({list}) => {
  return (
    <>
      {Object.entries(list.ballot).map(([key, value]) => (
        <Container key={key}>
          {key === "title" && <h1>{String(value)}</h1>}
          {key === "location" && <h2>{String(value)}</h2>}
          {key === "date" && <h2>{String(value)}</h2>}
          {key === "instructions" && BallotInstructions(value)}
          {key === "positions" && BallotCandidates(value)}
        </Container>
      ))}
    </>
  );
};

export default OptionsList;